<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert v-if="alert" :type="alert_type" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert >
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />
    <!--  -->
    <v-row justify="center">
      <v-dialog v-model="proposePopup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Re-Propose</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closePopup()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-text-field v-model="remarks" label="Enter Remarks" variant="outlined" class="ma-2"></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
              <v-btn size="small" variant="flat" color="primary" class="mb-3" :disabled="!remarks">Submit</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-approval" v-model="filterPopup" persistent max-width="700px">
        <v-card>
          <v-card-actions>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="user" label="Requested By" variant="outlined" class="ma-2" style="max-width: 350px;"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="path" label="Path" variant="outlined" class="ma-2" style="max-width: 350px;"></v-text-field>
            <!-- <v-combobox v-model="path" :items="filter_path" item-title="name" item-value="id" label="Path" style="width: 300px !important;" outlined ></v-combobox> -->
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" @click="closePopup">CANCEL</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="applyFilterFunc">APPLY FILTER(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- success popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <p class="text-center">{{ message }}</p>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" size="small" color="primary" class="mb-3" @click="closePopup">OK</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- search action and filter -->
    <v-card-title style="padding: 28px">
        <v-row>
          <v-row>
            <v-col cols="8" sm="8">
              <v-text-field prepend-inner-icon="mdi-magnify" v-model="pending_return_search" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData()"></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-card-actions style="margin-bottom: 28px;">
            <v-btn class="ma-2" variant="flat" :color="disableApprove() ? '' : 'primary'" :disabled = "disableApprove()" @click="rePropose">Re-propose</v-btn>
            <v-btn class="ma-2" variant="flat" :color="selected.length == 0 ? 'secondry' : 'green'" :disabled = "selected.length == 0" @click="approveRequest()">Approve</v-btn>
            <v-btn class="ma-2" variant="flat" :color="selected.length == 0 ? 'secondry' : 'red'" :disabled = "selected.length == 0" @click="rejectRequest()">reject</v-btn>
          </v-card-actions>
          <!-- filter -->
          <v-expansion-panels class="custom-control_outlined filter_style m-0" style="height: 56px" ref="filterPopupRef" >
            <v-expansion-panel variant="outlined" @click="handleFilterPopup">
              <v-expansion-panel-title>
                Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
    </v-card-title>
    <!-- table content -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%"
          :loading="loading"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
        >
          <!-- <template #[`item.tag_number`]="{ item }">
            <span>
              <a style="color: #1976d2;" @click="itemApproval(item)">
                <u> {{ item.tag_number }}</u>
              </a>
            </span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <div>
      <v-row class="ml-2 pb-0">
        <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
          variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </v-col>
        <span class="item-selected"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
            v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
        <v-spacer></v-spacer>
        <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
          - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
        <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
            @update:modelValue="handlePageChange" circle></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  import axios from 'axios';
  export default {
    data() {
      return {
        headerText: "Approval Request",
        alert: false,
        alert_message:null,
        alert_type:null,
        search_tag : null,
        selected: [],
        table_data : [],
        totalPages : 1,
        totalCount: '',
        pageSize : 50,
        pageSizes: [50,100,200],
        page : 1,
        user : null,
        path : null,
        filter_path: [],
        search : null,
        loading: false,
        pending_return_search :null,
        headers: [
          { title: "Tag ID", key: "tag_number", align: "start", sortable: false,},
          { title: "Approval Request No", key: "request_number", align: "start", sortable: false,},
          { title: "Requested By", key: "requested_by" },
          { title: "Article ID", key: "article_id" },
          { title: "Path", key: "path", sortable: false,},
          { title: "Requested Date", key: "requested_date" },
          { title: "Ageing", key: "ageing" }
        ],
        filterPopup : false,
        proposePopup : false,
        remarks : null,
        user_email :null,
        successPopup : false,
        message : null,
      }
    },
    components: {
      HeaderComponent
    },
    created() {
      this.loadData();
    },
    methods : {
      loadData() {
        this.selected = []
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.pageSize = 50
        this.user_email = this.$store.state.currentUser;
        this.loading = true,
        this.getPendingApproval();
      },
      getPendingApproval(){     
        const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/approval_records`;
        const params = { email: this.user_email.email, query: this.pending_return_search, page: this.page , per_page : this.pageSize};    
        axios.get(url, { params })
          .then(response => {
            this.table_data = response.data.approval_requests;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.loading = false
          })
          .catch(error => {
            if(error.response && error.response.data && error.response.data.message){
              this.showAlert("error", error.response.data.message);
            }else {
              this.$toast.error('Error sending approval request', error);
            }
          });
      },
      approveRequest() {
        const itemIds = this.selected.map(x => x.id);
        const item_token = this.selected.map(x => x.token)
        const urlMultipleItems = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/approve_requests`;
        const urlSingleItem = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${item_token}/approve_request`;

        if (itemIds.length > 1) {
          const data = { ids: itemIds, user_name: this.user_email.email };
          axios.put(urlMultipleItems, data)
            .then(response => {
              this.successPopup = true;
              this.message = response.data.message;
              this.loadData();
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.message) {
                this.showAlert("error", error.response.data.message);
              } else {
                  this.$toast.error('Error sending approval request', error);
              }
            });
        } else if (itemIds.length === 1) {
          const params = { user_name: this.user_email.email };
          axios.get(urlSingleItem, {params})
            .then(response => {
              this.successPopup = true;
              this.message = response.data.message;
              this.loadData();
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.message) {
                this.showAlert("error", error.response.data.message);
              } else {
                this.$toast.error('Error sending approval request', error);
              }
            });
        }
      },
      rejectRequest(){
        const itemIds = this.selected.map(x => x.id);
        const item_token = this.selected.map(x => x.token)
        const urlMultipleItems = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/reject_requests`;
        const urlSingleItem = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${item_token}/reject_request`;

        if (itemIds.length > 1) {
          const data = { ids: itemIds, user_name: this.user_email.email };
          axios.put(urlMultipleItems, data)
            .then(response => {
              this.successPopup = true;
              this.message = response.data.message;
              this.loadData();
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.message) {
                this.showAlert("error", error.response.data.message);
              } else {
                  this.$toast.error('Error sending approval request', error);
              }
            });
        } else if (itemIds.length === 1) {
          const params = { user_name: this.user_email.email };
          axios.get(urlSingleItem, {params})
            .then(response => {
              this.successPopup = true;
              this.message = response.data.message;
              this.loadData();
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.message) {
                this.showAlert("error", error.response.data.message);
              } else {
                this.$toast.error('Error sending approval request', error);
              }
            });
        }
      },
      rePropose(){
        const item_token = this.selected.map(x => x.token)
        const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${item_token}/repropose_request`;
        const data = { user_name: this.user_email.email };    
        axios.put(url, data)
          .then(response => {
            this.successPopup = true
            this.message = response.data.message
            this.loadData();
          })
          .catch(error => {
            if(error.response && error.response.data && error.response.data.message){
              this.showAlert("error", error.response.data.message);
            }else {
              this.$toast.error('Error sending approval request', error);
            }
          });
        // this.proposePopup = true
      },
      disableApprove() {
        return this.selected.length === 0 || this.selected.some(item => item.approval_flow === 'parallel');
      },
      applyFilterFunc(){
        const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/approval_records`;
        const params = { email: this.user_email.email, path: this.path, requested_by: this.user, page: this.page , per_page : this.pageSize };    
        axios.get(url, { params })
          .then(response => {
            this.table_data = response.data.approval_requests;
            this.filterPopup = false;
          })
          .catch(error => {
            if(error.response && error.response.data && error.response.data.message){
              this.showAlert("error", error.response.data.message);
            }else {
              this.$toast.error('Error sending approval request', error);
            }
          });
      },
      itemApproval(item){
        const item_value = item.tag_number
        this.$router.push({ name: "approvalItemDetails", params: { item_id: item_value} });
      },
      closePopup(){
        this.successPopup = false
        this.proposePopup = false
        this.filterPopup = false
        this.remarks = ''
        this.selected = []
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.makeLoadingFalse();
      },
      makeLoadingFalse(){
        setTimeout(() => {
          this.loading = false;
          this.alert = false;
        }, 3000);
      },
      handleFilterPopup (){
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.filterPopup =  true
        this.user = '';
        this.path = '';
        this.pending_return_search = ''
      },
      handlePageSizeChange(){
        this.getPendingApproval()
      },
      handlePageChange(){
        this.getPendingApproval()
      },
    }
  }
</script>
<style>

  .v-dialog__content:has(.filter-approval){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .green{
    background: #219653;
    color: #fff !important;
  }
  .red{
    background: #EC0101;
    color: #fff !important;
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
</style>